import { render, staticRenderFns } from "./programcontentsform.vue?vue&type=template&id=1a340fb4&"
import script from "./programcontentsform.vue?vue&type=script&lang=ts&"
export * from "./programcontentsform.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports